import { HttpEvent, HttpHandlerFn,HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthService } from '../services/auth.service';

const skipURLs: string[] = [];

export function shouldSkipUrl(url: string): boolean {
  return skipURLs.some((skipUrl) => url.includes(skipUrl));
}

export function JwtInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const authService = inject(AuthService);
  if (authService.isLoggedIn() && !shouldSkipUrl(req.url)) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${authService.getUserToken()}`,
      },
    });
  }

  return next(req);
}
